import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
// MessageBox
// import { getCookie,  } from '@/utils/cookies'
// clearCookie
// create an axios instance
//创建一个axios实例
export let FILEAPI = "http://staticsr.shurenzixun.com/mls/files/"
// export let FILEAPI = "https://xiaotantest.oss-cn-qingdao.aliyuncs.com/"
const service = axios.create({
  // baseURL: process.env.VUE_APP_API,
  // baseURL: 'http://30r14r0455.qicp.vip',
  // baseURL: 'http://192.168.0.119:8086/v1',
  baseURL: process.env.VUE_APP_API,
  // baseURL: '',
  // baseURL: 'http://192.168.0.2:8086',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  res => {
    // do something before request is sent
    //在发送请求之前做些什么
    let token =   localStorage.getItem("token");
    
    if (res) {
      if (token) {
        res.headers.token = token
      }
      return res
    }
    // if (store.getters.token) {
    //   // let each request carry token  让每个请求携带令牌
    //   // ['X-Token'] is a custom headers key ['X-Token']是一个自定义的标头键
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken()
    // }
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // return response.data
    const res = response.data
    if (res.code !== '200') {
      // Message({
      //   message: res.msg || 'Error',
      //   type: 'warning',
      //   duration: 3 * 1000
      // })
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== '200' && !res.success) {
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === '403') {
        // to re-login
        // MessageBox.Dialog.props.closeOnClickModal.default = false; 
        MessageBox.confirm('您的账号无登录权限或已在其它地方登录', '确认登出', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal:false
        }).then(() => {
          localStorage.setItem('token','')
          window.location = '/'
        }).catch(()=>{
          localStorage.setItem('token','')
          window.location = '/'
        })
      } else {
        Message({
          message: res.msg || 'Error',
          type: 'warning',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.msg,
      type: 'warning',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
